import React from 'react'

const ArrowDownGraySvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 12.972 7.9'
    >
      <path
        id='Path_3208'
        data-name='Path 3208'
        d='M14906.687,3248.5l5.778,5.779,5.779-5.779'
        transform='translate(-14905.979 -3247.793)'
        fill='none'
        stroke='#C8C8C8'
        strokeWidth='2'
      />
    </svg>
  )
}

export default ArrowDownGraySvg
